// extracted by mini-css-extract-plugin
export default {"root":"ordersHeading_root__fl9rQ","input":"ordersHeading_input__-DtJJ","titleOrder":"ordersHeading_titleOrder__xJqYS","without_input":"ordersHeading_without_input__bmYih"};